// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
export const environment = {
  production: false,
  baseUrl: 'https://demo-crm-new-api.attractor-school.com/',
  wsUrl: 'wss://demo-crm-new-api.attractor-school.com/',
  GoogleDiskUrls: {
    exelStudentsImport:
      'https://docs.google.com/spreadsheets/d/1y1kDC0Hpvin5rBWxpnTDFgEmYMmB6zFiUjAk7relCa0/edit#gid=1745580776/',
  },
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
